import { fetchGetters } from '@/store/extensions/fetch';

export default {
  ...fetchGetters,
};



// WEBPACK FOOTER //
// ./src/store/modules/payroll/getters.js